import {UI} from "../../../../../stem-core/ui/UIBase";

import {BasePanelPage} from "../../../PanelPage";
import {Messages} from "../../../../Messages";
import {wrapInSpinner} from "../../../../../core/ui/LoadingSpinner.jsx";
import {Router} from "../../../../../stem-core/ui/Router";
import {apiDeleteAddress, UserAddress} from "../../../../../client/state/UserAddressStore";
import {Flow} from "../../../flows/Flow.js";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {autoredraw} from "../../../../../stem-core/decorators/AutoRedraw";
import {Toast} from "../../../../ui/Toast.jsx";
import {BlinkButton} from "../../../../../core/ui/Button.jsx";
import {BackButton} from "../../../../../core/ui/LinkButton.jsx";


@autoredraw(UserAddress)
export class UserDashboardRemoveAddressPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.removeAddress,
        };
    }

    @wrapInSpinner
    async removeAddress() {
        await apiDeleteAddress(Flow.address.selectedValue.id);
        Router.back();
        Toast.showSuccess(Messages.addressRemoved);
    }

    render() {
        const {styleSheet} = this;

        return [
            <MessageElement message={Messages.deleteAddressDescription(Flow.address.selectedValue.toString())}/>,
            <BlinkButton
                label={Messages.remove}
                className={styleSheet.actionButton}
                onClick={() => this.removeAddress()}
            />,
            <BackButton label={Messages.cancel} />,
        ];
    }
}
